import styled from 'styled-components'

const EmptyColumn = styled.div``
export { EmptyColumn }
